import { Helper } from "../../core/util/helper";
import { AppBaseProps, CommonApp, Context } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { TemplateRequirementsEntity } from "./workPackage";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";

export class EditWorkPackageReportApp extends React.Component<EditWorkPackageReportProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    parentContextType: string;
    constructor(props: EditWorkPackageReportProps) {
        super(props);
        this.common.enableHooks = true;
        this.parentContextType = props.context.parentContextType;
       
        this.common.init(this);     
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.MaschNr":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.MaschNr", dataItem.Key);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.MaschBezeichnung", dataItem.Value);
                }
                break;
            case "entity.LinkedTypeValue":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.LinkedType", { Name: dataItem.Name, Title: dataItem.Title, Value: dataItem.Value });
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.LinkedTypeValue", dataItem.Value);
                }
                break;
            default:
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    apply = () => {
        if (this.common.validate()) {
            this.common.setEntityDirtyState(false);
            this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
            this.common.sheetWrapper.hide();
        }
    }
    handleIsSearchFieldFullObjectModel = (field, dataItem) => {
        let changed = true;
        switch (field.model) {
            case "entity.Title":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Title", dataItem.Title);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.TemplateId", dataItem.Id);
                }
                break;
            default:
                changed = false;
                break;             
        }
        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }
    render() {
        const props = $.extend({}, this.props, 
            this.common.getHandlersForProps(), 
            { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel});
        return <CommonApp {...props} />;
    }
}

interface EditWorkPackageReportContext extends Context
{
    parentContextType: string;
}

export interface EditWorkPackageReportProps extends AppBaseProps {
    disabled: boolean;
    entity: TemplateRequirementsEntity;
    context: EditWorkPackageReportContext
}